import { NotificationEventType } from '../types/notification-event-type';
import { NotificationPriority } from '../types/notification-priority';

export class NotificationSetting {
  /**
   * Notification Setting type
   */
  type: NotificationEventType;

  /**
   * Is the Notification Setting activated
   */
  activated: boolean;

  /**
   * Priority of the Notification Setting
   */
  priority?: NotificationPriority;

  constructor(attributes: Partial<NotificationSetting> = {}) {
    Object.assign(this, attributes);
  }
}
